<div
  class="notif-informer-root"
  *ngIf="visible"
  [class.is-suivi-etablissement]="estSuiviEtablissement"
  (click)="openFromToast()"
>
  <div class="notif-informer-card" [style.--informer-tone-color]="toneColor" role="status" aria-live="polite">
    <div class="notif-informer-bar" aria-hidden="true"></div>

    <div class="notif-informer-content">
      <div class="notif-informer-title">{{ notification?.titre }}</div>
      <span class="notif-informer-suivi" *ngIf="estSuiviEtablissement">
        <ion-icon name="business-outline"></ion-icon>
        {{ 'notifications.suiviEtablissement' | translate }}
      </span>
      <div class="notif-informer-subtitle">{{ subtitle }}</div>
    </div>

    <button type="button" class="notif-informer-close" (click)="close($event)" aria-label="Fermer">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
</div>

